/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import BooleanRadioFieldComponent from 'components/formFields/booleanRadio';
import IntlMessageComponent from 'components/formatters/intlMessage';
import OfficeFieldComponent from 'components/formFields/offices';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import RoleFieldISOComponent from 'components/formFields/types/roleISOs';
import EmailTypeFieldComponent from 'components/formFields/types/email';
import ToolTipComponent from 'components/toolTips';

import CompanyUserForm from '../model';
import { ISO_ROLE_ADMINISTRATOR, ISO_ROLE_ACCOUNTANT, ISO_ROLE_ACCOUNT_MANAGER, ISO_ROLE_NETWORK_MANAGER, ISO_ROLE_OFFICE_MANAGER } from 'constants/constants';

type CompanyUsersFormCompanyInfoISOPanelComponentProps = {
  defaultFieldOptions: any;
  errors: Map<string,?string>;
  form: CompanyUserForm;
  isProcessing: boolean;
  userPersonRoleIsActive: boolean;
  hasProcuration: boolean;
  hasProcurationUsers: boolean;
  hasProcurationGeneralConditions: boolean;
  handleChange: (fieldName: string) => (event: SyntheticInputEvent<HTMLInputElement>) => void;
  handleBooleanChange: (fieldName: string) => (event: SyntheticInputEvent<HTMLInputElement>) => void;
  handleTypeChange: (fieldName: string) => (id: number) => void;
  newOffice: () => void;
}

export default function CompanyUsersFormCompanyInfoISOPanelComponent(props: CompanyUsersFormCompanyInfoISOPanelComponentProps) {
  return (
    <React.Fragment>
      <PageSubTitleViewComponent id="page.profile.users.role" />
      <Box p={2} bgcolor="lightblue.dark">
        <IntlMessageComponent id="page.profile.iso.rolebox" />
      </Box>
      {props.form.companyUserId === 0 && (<Box mt={3} px={4}>
        <BooleanRadioFieldComponent
          id="form.isAdministrator"
          error={!!props.errors.get('isAdministrator')}
          label={<IntlMessageComponent id="form.isAdministrator.addUser" />}
          name="isAdministrator"
          value={props.form.isAdministrator?.toString() || 'false'}
          onChange={props.handleBooleanChange('isAdministrator')}
        />
      </Box>
      )}
      <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
        <Grid item xs={12} md={6}>
          <Box px={4}>
            <OfficeFieldComponent
              id="office"
              label={<IntlMessageComponent id={`form.office.label`} />}
              error={!!props.errors.get('officeId')}
              helperText={props.errors.get('officeId') ?
                <IntlMessageComponent id={props.errors.get('officeId')} /> : ''}
              value={props.form.officeId}
              changeHandler={props.handleTypeChange('officeId')}
              fullWidth
              margin="normal"
              required
            />
            <Link
              component="button"
              variant="body2"
              disabled={props.isProcessing}
              onClick={props.newOffice}
            ><b><IntlMessageComponent id="page.profile.users.newoffice" /></b></Link>
          </Box>
        </Grid>

        {props.userPersonRoleIsActive && <Grid item xs={12} md={6}>
          <Box px={4}>
            <RoleFieldISOComponent
              id="form.isoRole"
              label={<IntlMessageComponent id="form.isoRole.label" />}
              error={!!props.errors.get('isoRoleId')}
              helperText={props.errors.get('isoRoleId') ?
                <IntlMessageComponent id={props.errors.get('isoRoleId')} /> : ''}
              value={props.form.isoRoleId}
              changeHandler={props.handleTypeChange('isoRoleId')}
              fullWidth
              margin="normal"
              required
              hasProcuration={props.hasProcuration}
              hasProcurationUsers={props.hasProcurationUsers}
              hasProcurationGeneralConditions={props.hasProcurationGeneralConditions}
              isAdministrator={props.form.isAdministrator}
              hasAdministratorRole={props.form.isoRoleId === ISO_ROLE_ADMINISTRATOR}
              InputProps={{
                startAdornment: (props.form.isoRoleId ?
                  <InputAdornment position="start">
                    <ToolTipComponent
                      pageName={"Tooltip"}
                      elementName={"iso.roles.explanation"}
                    />
                  </InputAdornment> : "")
              }}
            />
          </Box>
        </Grid>}
      </Grid>

      <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
        <Grid item xs={12} md={6}>
          <Box px={4}>
            <TextField
              id="form.functionName"
              label={<IntlMessageComponent id="form.functionName" />}
              error={!!props.errors.get('functionName')}
              helperText={props.errors.get('functionName') ?
                <IntlMessageComponent id={props.errors.get('functionName')} /> : ''}
              value={props.form.functionName}
              onChange={props.handleChange('functionName')}
              fullWidth
              margin="normal"
              required
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box px={4}>
            <EmailTypeFieldComponent
              label={<IntlMessageComponent id="form.isoCommissionEmailTypeId.label" />}
              error={!!props.errors.get('isoCommissionEmailTypeId')}
              helperText={(props.errors.get('isoCommissionEmailTypeId')) ?
                <IntlMessageComponent id={props.errors.get('isoCommissionEmailTypeId')} /> : ''}
              value={props.form.isoCommissionEmailTypeId}
              changeHandler={props.handleTypeChange('isoCommissionEmailTypeId')}
              fullWidth
              margin="normal"
              required
            />
          </Box>
        </Grid>
      </Grid>


    </React.Fragment>
  );
}
